import styled from "styled-components";

export const CardContainer = styled.div`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    border-color: #d9d9d9;

    .prev,
    .next {
      opacity: 1;
    }
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  height: 24px;
`;

export const CarouselContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  width: 100%;
  height: 200px;
  overflow: visible;

  .product-carousel {
    width: 100%;
  }

  .slick-dots {
    bottom: -10px !important;

    li {
      margin: 0 3px !important;
      width: 6px !important;
      height: 6px !important;

      button {
        width: 6px !important;
        height: 6px !important;
        border-radius: 50% !important;
        background: #4a4a68 !important;
        opacity: 0.3 !important;
        padding: 0 !important;
      }

      &.slick-active {
        width: 18px !important;

        button {
          width: 18px !important;
          border-radius: 4px !important;
          background: #2060ea !important;
          opacity: 1 !important;
        }
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 180px;

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    margin: 0 auto;
  }
`;

export const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  opacity: 0;

  &:hover {
    background: #f7f8f9;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  &.prev {
    left: -8px;
  }

  &.next {
    right: -8px;
  }

  svg {
    color: #4a4a68;
  }
`;

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const SkuAndCase = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 10px;
  color: #4a4a68;

  .sku {
    color: #686978;
  }
`;

export const ProductName = styled.h3`
  font-size: 14px;
  color: #0e0e2c;
  margin: 0;
  line-height: 1.4;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: Inter, sans-serif;
  margin-bottom: 8px;

  .price-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }

  .price {
    font-size: 16px;
    color: #0e0e2c;
  }

  .original-price {
    font-size: 12px;
    color: #4a4a68;
    text-decoration: line-through;
    font-weight: 400;
  }

  .not-available {
    font-size: 14px;
    color: #b0b0b8;
    font-weight: 400;
    font-style: italic;
  }
`;

export const TierInfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: #686978;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;

  &:hover {
    color: #2060ea;
  }
`;

export const TierPopoverPanel = styled.div`
  min-width: 200px;
  max-width: 280px;

  .tier-popover-hint {
    font-size: 11px;
    font-weight: 400;
    color: #686978;
    line-height: 1.35;
    margin-bottom: 10px;
  }

  .tier-popover-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const TierPopoverRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 8px;
  border-radius: 4px;
  background: ${props => (props.$active ? "#edf3ff" : "transparent")};
  border: 1px solid ${props => (props.$active ? "#c9dbff" : "transparent")};

  .tier-range {
    font-size: 12px;
    font-weight: ${props => (props.$active ? 600 : 400)};
    color: ${props => (props.$active ? "#1249bf" : "#4a4a68")};
    white-space: nowrap;
  }

  .tier-price {
    font-size: 12px;
    font-weight: 600;
    color: #0e0e2c;
    white-space: nowrap;
  }
`;

export const CardActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: auto;
`;

export const QuantitySelector = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  border: 1px solid #ecf1f4;
  border-radius: 4px;
  height: 32px;
  padding: 4px 15px;
  background: #ffffff;

  button {
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
      color: #2060ea;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .quantity-value {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #4a4a68;
    width: 64px;
    border: none;
    background: transparent;
    outline: none;
    padding: 0;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

export const AddButton = styled.button`
  flex-grow: 1;
  background: #1249bf;
  border: none;
  color: #ffffff;
  border-radius: 4px;
  height: 32px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background: #0f3da3;
  }

  &:disabled {
    background: #cccccc;
    color: #888888;
    cursor: not-allowed;
  }
`;
